import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTheme } from '@material-ui/core/styles';

// components
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import LoadingButton from 'components/shared/LoadingButton';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ViewState } from '@devexpress/dx-react-scheduler';
import {
  Scheduler,
  DateNavigator,
  Toolbar,
  TodayButton,
} from '@devexpress/dx-react-scheduler-material-ui';

//hooks
import { useDivisionValue } from 'providers/DivisionProvider';

// icons
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { Grid } from '@material-ui/core';
import { CalendarMonthOutlined } from '@mui/icons-material';
import Typography from 'components/shared/Typography';
import { SPACING_LEAST } from 'constants/spacing';

const ExternalViewSwitcher = ({ currentViewName, onChange }) => (
  <RadioGroup
    aria-label="Views"
    style={{ flexDirection: 'row' }}
    name="views"
    value={currentViewName}
    onChange={onChange}
  >
    <FormControlLabel value="Month" control={<Radio />} label="ماه" />
    <FormControlLabel value="Week" control={<Radio />} label="هفته" />
    <FormControlLabel value="Day" control={<Radio />} label="روز" />
  </RadioGroup>
);

/**
 * @component Calendar
 */
function Calendar({
  selectedDate,
  selectEventHandler,
  events,
  handleEventClick,
  setCurrentDate,
  currentDate,
  isLoading,
}) {
  const [currentViewName, setCurrentViewName] = useState('Month');

  const [localCurrentDate, setLocalCurrentDate] = useState(new Date());

  const division = useDivisionValue();

  const theme = useTheme();
  // const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const mobileDevice = true;

  const timeOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  };

  useEffect(() => {
    setLocalCurrentDate(currentDate);
  }, [currentDate]);

  useEffect(() => {
    const newView = 'Day';
    // const newView = mobileDevice ? 'Day' : 'Month';

    setCurrentViewName(newView);
  }, [mobileDevice]);

  const currentViewNameChange = (e) => {
    setCurrentViewName(e.target.value);
  };

  const TodayComponent = (props) => {
    return (
      <div style={{ position: 'relative', right: '-6%', marginLeft: '7%' }}>
        <LoadingButton
          variant="contained"
          color="primary"
          size="small"
          style={{ position: 'relative', right: 0 }}
          onClick={() => setCurrentDate(new Date())}
          {...props}
        >
          {'< برو به امروز '}
        </LoadingButton>
      </div>
    );
  };
  const NavComponent = (props) => {
    return (
      <IconButton
        onClick={() => {
          if (props.type === 'back') {
            setCurrentDate(new Date(currentDate.getTime() - 86400000));
            setLocalCurrentDate(new Date(currentDate.getTime() - 86400000));
          } else {
            setCurrentDate(new Date(currentDate.getTime() + 86400000));
            setLocalCurrentDate(new Date(currentDate.getTime() + 86400000));
          }
        }}
      >
        {props.type === 'back' ? (
          <Tooltip title="قبلی">
            <ChevronRight />
          </Tooltip>
        ) : (
          <Tooltip title="بعدی">
            <ChevronLeft />
          </Tooltip>
        )}
      </IconButton>
    );
  };
  const navigationButton = ({ onVisibilityToggle }) => {
    return (
      <Grid
        container
        style={{
          width: '180%',
          height: '100%',
          justifyContent: 'space-between',
          direction: 'revert',
        }}
      >
        <div
          style={{
            top: '70%',
            left: '46%',
            position: 'absolute',
            transform: 'translateX(-50%)',
          }}
        >
          <Typography>
            {currentDate.toLocaleDateString('fa-IR', { day: 'numeric', month: 'long' })}
          </Typography>
        </div>

        <div style={{ top: '10%', left: '5%', position: 'absolute' }}>
          <IconButton onClick={onVisibilityToggle}>
            <CalendarMonthOutlined style={{ fontSize: '32px' }} />
          </IconButton>
        </div>
      </Grid>
    );
  };

  return (
    <>
      {!mobileDevice ? (
        <ExternalViewSwitcher
          currentViewName={currentViewName}
          onChange={currentViewNameChange}
        />
      ) : null}
      <Paper style={{ marginTop: 16, height: '100%' }}>
        <Scheduler
          data={events}
          // data={[{
          //   start: testStart.getTime(),
          //   end:testEnd.getTime()
          // }]}
          height={100}
          showAllDayPanel={false}
          firstDayOfWeek={6}
          locale="fa"
        >
          <ViewState
            defaultCurrentDate={currentDate}
            currentViewName={currentViewName}
            onCurrentDateChange={(e) => {
              setCurrentDate(e);
            }}
          />

          <Toolbar dir="ltr" />
          <DateNavigator
            openButtonComponent={navigationButton}
            navigationButtonComponent={NavComponent}
          />
          <TodayButton buttonComponent={TodayComponent} />
        </Scheduler>

        {isLoading ? (
          <CircularProgress size={55} />
        ) : (
          <Grid
            item
            xs={12}
            style={{
              marginTop: '3%',
              paddingRight: '10%',
            }}
          >
            <Grid container spacing={SPACING_LEAST} style={{ justifyContent: 'space-evenly' }}>
              {events.filter((appointment) => appointment.selectable).length === 0 && (
                <Typography variant="h5" color="error">
                  هیچ وقت خالی برای این روز وجود ندارد. لطفا روز دیگری را انتخاب کنید.
                </Typography>
              )}
              {events.map((appointment) => {
                return (
                  appointment.selectable && (
                    <>
                      <Grid item xs={5}>
                        <div
                          onClick={(event) => {
                            console.log('asdsadasdasdsa');
                            if (!appointment?.selectable) return false;
                            console.log('event!!', appointment);
                            selectEventHandler(appointment);
                            return false;
                          }}
                          style={{
                            border: ' 2px solid',
                            borderColor: '#24AF6ECC',
                            cursor: 'grab',
                            minHeight: '45px',
                            backgroundColor: !appointment?.selectable
                              ? '#FCE7E9'
                              : selectedDate?.startDate === appointment?.startDate
                              ? '#24AF6ECC'
                              : '#F7F9FC',
                            borderRadius: '4px',
                            display: 'grid',
                            alignContent: 'center',
                          }}
                        >
                          <Typography variant="body1">
                            {`${appointment.startDate.toLocaleTimeString(
                              'fa-IR',
                              timeOptions
                            )}-${appointment.endDate.toLocaleTimeString(
                              'fa-IR',
                              timeOptions
                            )}`}
                          </Typography>
                        </div>
                      </Grid>
                    </>
                  )
                );
              })}
            </Grid>
          </Grid>
        )}
      </Paper>
    </>
  );
}

export default Calendar;
